import { render } from "./MenuItemsNestedDraggable.vue?vue&type=template&id=3aa956ee&scoped=true"
import script from "./MenuItemsNestedDraggable.vue?vue&type=script&lang=ts"
export * from "./MenuItemsNestedDraggable.vue?vue&type=script&lang=ts"

import "./MenuItemsNestedDraggable.vue?vue&type=style&index=0&id=3aa956ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3aa956ee"

export default script